/**
 * Import required libraries
 */
import React, { useState } from "react";
import { connect } from "react-redux";
import { getLabel } from "Utils";

/**
 * Import required elements
 */
import Category from "./Category";
// Material-ui components
import { MenuList, MenuItem } from "@material-ui/core";
// Material-ui icons
import {
  // Business as GroupIcon,
  // ViewCompact as ProjectIcon,
  PeopleSharp as PrivateIcon
} from "@material-ui/icons";

import styles from "./styles";

const categories = {
  // groups: {
  //   label: {
  //     en: "Groups",
  //     fr: "Groupes"
  //   },
  //   Icon: GroupIcon
  // },
  //projects: {
  //  label: {
  //    en: "Projects",
  //    fr: "Projets"
  //  },
  //  Icon: ProjectIcon
  //},
  privates: {
    label: {
      en: "Privates",
      fr: "Privés"
    },
    Icon: PrivateIcon
  }
};

/**
 * NewChat Component
 */
function NewChat({ lang, close, ...props }) {
  const [category, setCategory] = useState(null);

  const _label = lab => getLabel(lab, lang, "Footer/ChatRooms");
  // CSS classnames
  const classes = styles();

  return (
    <div className={classes.root}>
      {category === null ? (
        <MenuList className={classes.menuList}>
          {Object.entries(categories).map(([k, { label, Icon }]) => (
            <MenuItem key={k} onClick={e => setCategory(k)}>
              <div className={classes.item}>
                <Icon className={classes.itemIcon} />
                {_label(label)}
              </div>
            </MenuItem>
          ))}
        </MenuList>
      ) : (
        <Category
          category={category}
          back={e => setCategory(null)}
          close ={close}
          popupProps ={props}
        />
      )}
    </div>
  );
}

/**
 * Export component
 */
// map redux state to props
export default connect(state => ({
  lang: state.locale.lang
}))(NewChat);
